import { render, staticRenderFns } from "./EnrollKid.vue?vue&type=template&id=5ef3de3a&scoped=true"
import script from "./EnrollKid.vue?vue&type=script&lang=js"
export * from "./EnrollKid.vue?vue&type=script&lang=js"
import style0 from "./EnrollKid.vue?vue&type=style&index=0&id=5ef3de3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef3de3a",
  null
  
)

export default component.exports